import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';
import QuestionForm from '../components/features/forum/QuestionForm';
import Container from '../components/common/Container';
import Button from '../components/common/Button';


const QuestionCreatePage = () => {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [isFormOpen] = useState(true);

  // Redirect if not authenticated
  if (!user) {
    navigate('/login');
    return null;
  }

  const handleQuestionCreated = (question) => {
    // Navigate to the newly created question
    navigate(`/forum/${question.id}`);
  };

  const handleClose = () => {
    // Navigate back to forum
    navigate('/forum');
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <Container>
        {/* Header */}
        <div className="mb-8">

          
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Ask a Question
          </h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Share your question with the community and get helpful answers from fellow professionals.
          </p>
        </div>

        {/* Question Form Modal */}
        <QuestionForm
          isOpen={isFormOpen}
          onClose={handleClose}
          onQuestionCreated={handleQuestionCreated}
          mode="create"
        />
      </Container>
    </div>
  );
};

export default QuestionCreatePage;